import axios, { AxiosResponse } from 'axios';
import { handleAxiosError } from '@/functions/handleAxiosError';

import { AddressResult } from './types';

const instance = axios.create({
	withCredentials: false,
	baseURL: 'https://data.geopf.fr/geocodage',
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	}
});

instance.interceptors.response.use(
	undefined,
	(error) => handleAxiosError(error, 'Erreur liée à la suggestion d\'adresse : merci de saisir à nouveau votre recherche.')
);

export function searchAddress(query: string): Promise<AxiosResponse<AddressResult>> {
	return instance.get('/completion', {
		params: {
			text: query,
			type: 'StreetAddress',
			maximumResponses: 5
		}
	});
}
